import axios from 'axios';

import api from '../../helpers/axiosHelper';
import { API_ROOT_URL } from '../../helpers/api';
import {
  IMAGINE_AI_BULK_CREATE_API,
  IMAGINE_AI_FILE_UPLOADED_API,
  IMAGINE_AI_UPDATE_OUTPUT_CURATOR_API,
  IMAGINE_AI_UPLOAD_JOB_STATUS_API,
} from '../../config/constant/apiConstant';

// GET — list pending background upload jobs
export const getUploadJobStatus = () =>
  api()
    .root(API_ROOT_URL)
    .get(IMAGINE_AI_UPLOAD_JOB_STATUS_API)
    .requestConfig({ messages: { hideTost: true } })
    .success((res) => res)
    .error(() => null)
    .send();

// POST — register an output/link asset and (for output items) receive presigned upload data
export const postBulkCreateImagineAsset = (formData) =>
  api()
    .root(API_ROOT_URL)
    .post(IMAGINE_AI_BULK_CREATE_API)
    .data(formData)
    .requestConfig({ messages: { hideTost: true } })
    .success((res) => res)
    .error(() => null)
    .send();

// POST — notify backend that the listed tracking ids have been uploaded
export const notifyFilesUploaded = (trackingIds) =>
  api()
    .root(API_ROOT_URL)
    .post(IMAGINE_AI_FILE_UPLOADED_API)
    .data(JSON.stringify({ tracking_ids: trackingIds }))
    .setHeaders({ 'Content-Type': 'application/json' })
    .requestConfig({ messages: { hideTost: true } })
    .success((res) => res)
    .error(() => null)
    .send();

// DELETE — bypass tracking ids that have failed upstream (failed/error status)
export const bypassFailedUploadEntries = async (trackingIds) => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.delete(`${API_ROOT_URL}${IMAGINE_AI_FILE_UPLOADED_API}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      data: { tracking_ids: trackingIds },
    });
    return response?.data ?? null;
  } catch {
    return null;
  }
};

// Fire-and-forget PATCH to mark output creation on curator items
export const triggerUpdateOutputCurator = (id) => {
  if (id === null || id === undefined || id === '') return;
  const url = IMAGINE_AI_UPDATE_OUTPUT_CURATOR_API.replace(':id', String(id));
  void api()
    .root(API_ROOT_URL)
    .patch(url)
    .data(JSON.stringify({}))
    .setHeaders({ 'Content-Type': 'application/json' })
    .requestConfig({ messages: { hideTost: true } })
    .success((res) => res)
    .error(() => null)
    .send();
};

// Upload a file to S3 via presigned POST data ({ url, fields }).
export const postFileToPresignedData = async (file, presignedData) => {
  if (!presignedData?.url || !presignedData?.fields || !file) return null;
  const formData = new FormData();
  Object.entries(presignedData.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', file);
  return axios.post(presignedData.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
